import React from "react";
import { SvgIcon } from "../../../src/index";
var compPaths = {
  s: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M12 18.75H.75V5.25H12m0 0h11.25v13.5H12"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6.68 8.25h1.77l2.65 7.5H9.4l-.49-1.54H6.15l-.51 1.54H4l2.68-7.5zm-.11 4.67h1.92l-.94-2.96-.98 2.96z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M18 10c0 .746-.183 1.461-.514 2.108a5.516 5.516 0 01-1.403 1.728A6.672 6.672 0 0114 15"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M15.014 12.108c.33.647.807 1.233 1.403 1.728.597.494 1.294.89 2.083 1.164m-2.25-6.75V10"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M12.5 10H20"
  })),
  m: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M12 18.75H.75V5.25H12m0 0h11.25v13.5H12"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6.68 8.25h1.77l2.65 7.5H9.4l-.49-1.54H6.15l-.51 1.54H4l2.68-7.5zm-.11 4.67h1.92l-.94-2.96-.98 2.96z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M18 10c0 .746-.183 1.461-.514 2.108a5.516 5.516 0 01-1.403 1.728A6.672 6.672 0 0114 15"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M15.014 12.108c.33.647.807 1.233 1.403 1.728.597.494 1.294.89 2.083 1.164m-2.25-6.75V10"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M12.5 10H20"
  })),
  l: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M24 37.5H1.5v-27H24m0 0h22.5v27H24"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M13.36 16.5h3.54l5.3 15h-3.4l-.98-3.08H12.3l-1.02 3.08H8l5.36-15zm-.22 9.34h3.84l-1.88-5.92-1.96 5.92z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M36 20a9.245 9.245 0 01-1.028 4.216c-.66 1.294-1.614 2.466-2.807 3.455A13.34 13.34 0 0128 30"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M30.027 24.216c.661 1.294 1.615 2.466 2.808 3.455A13.356 13.356 0 0037 30.001M32.5 16.5V20"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M25 20h15"
  }))
};
export var Translation = /*#__PURE__*/React.memo(function (props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths,
    fill: "none"
  }));
});